import React, { Component } from 'react';
import Modal from "react-bootstrap/Modal";
import * as actions from '../../../store/actions';
import $ from 'jquery';
import { isSet } from '../../../Utils/CommonFunctions';
import { connect } from 'react-redux';
//import { updateInputValuesPayloadAction } from '../../../store/actions/StepsFlowAction';
import StepsTreeElements from './StepsTreeContent';

class AutomationInputVariablesPopup extends Component {
	// constructor(props) {
	// 	super(props);
	// 	this.state = {

	// 	}
	// }

	componentDidMount = ()=>{
		$('ul.treeSkeleton .treeSkeletonList').hide();
		this.jqueryScript();
	}
	jqueryScript = ()=>{
		$(function () {
			$('.treeSkeleton li > .treeSkeletonList').each(function (span) {
				var $subUl = $(this);
				var $parentLi = $subUl.parent('li');
				var $toggleIcon = '<span class="treetoggleIcon">+</span>';
		
				$parentLi.addClass('has-children treewithHeader');
				if($parentLi.closest('li').find('.treetoggleIcon').length==0){
				$parentLi.prepend($toggleIcon).find('.treetoggleIcon').on('click', function () {
					// if(!$(this).text()==='-'){
						// console.log('$subUl',$subUl);
						if($subUl.css('display') == 'none')
						{
							$(this).text('-');
							$subUl.slideDown('fast');
						}else{
							$(this).text('+');
							$subUl.slideUp('fast');
						}
						// $(this).text($(this).text() == '+' ? '-' : '+');
						// $subUl.slideToggle('fast');
					// }
					});
				}
			});
		});
	}
	updateValuesHandler = (varId,varName,val)=>{
		//console.log('updateValuesHandler==',varId,varName,val)
		const {inputValuesPayload} =  this.props;
		const indexing = inputValuesPayload.findIndex((i)=>i.variable_id===varId);
		let updatePayload = [...inputValuesPayload];
		if(indexing===-1){
			const newVal = {
				variable_id : varId,
				variable_name:varName,
				tabledescriptor_id : "",
				values : [{
					value:val
				}]
			}
			updatePayload.push(newVal);
		}else{
			updatePayload[indexing]['values'][0]["value"] = val;
		}		
		this.props.updateInputValuesPayloadAction(updatePayload);
	}
	formFieldsHandler = (varId,varName,e,type='TextInput')=>{
        // console.log('eeee...',varId,varName,e,type);
        let fieldValue = null;
        let displayName = null;
        if(type==='MultiSelect'){
            let MultiSelectValue = [];
            e = (e===null)?[]:e;
            e.map((item)=>{
                MultiSelectValue.push(item.id);
                    return item;
            }); 
            fieldValue = MultiSelectValue.join(',');
        }else if(type==='CheckBoxes'){
            fieldValue = e.target.checked;
        }else if(type==='date'){
            fieldValue = isSet(e,'');
        }else if(['number','phoneNumber','PickList'].indexOf(type)!==-1){
            fieldValue = e
        }else if(['Lookup','MultiLookup'].indexOf(type)!==-1){
            fieldValue = e.selectedValue;
            displayName = e.displayValue;
            // console.log('e',e);
        }else if(type==='currencyType'){
			fieldValue = '';
		}else if(type==='Files'){
            fieldValue = e;
        }else{ 
            fieldValue = e.target.value;
        }
		this.updateValuesHandler(varId,varName,fieldValue);
	}
	render(){
		const {toggleModel,variablesList} = this.props;
		//console.log('render111')
		return(
			<Modal size="fullscreen" className="modal-fullscreen" show={true}>
            <Modal.Header>
                <h4 className="modal-title secondary_color pl-2 mb-0"> Input Variables </h4>
            </Modal.Header>

            <Modal.Body>
			<div className="card m-2">
		     	<div className="card-body p-2">
					<ul className="treeSkeleton treeSkeletonList">
						<StepsTreeElements 
							variablesList={variablesList} 
							fieldKey={'default'}
							updateValuesHandler={this.updateValuesHandler}
							formFieldsHandler={this.formFieldsHandler}
							winId={''} 
							inputValuesPayload={this.props.inputValuesPayload}
						/>
					</ul>
				</div>
			</div>
            </Modal.Body>

            <Modal.Footer>
            	<div className="ml-md-auto py-2 py-md-0">
                    <a onClick={toggleModel} className="btn btn-border border-default mr-2" data-dismiss="modal"> Close </a> 
					<a onClick={()=>this.props.executeResultToogle(true)} className="btn primary_bg mr-2" data-dismiss="modal"> Save </a> 
                </div>
            </Modal.Footer>
		</Modal>
		)
	}
}


export default AutomationInputVariablesPopup;

